import {GetRefundModalities} from 'domain/usecases';
import {makeBFFApiUrl} from 'main/factories/http';

import {RemoteRefundGetModalities} from 'data/usecases';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';

import {RefundFlowEndPoints} from '../../../endpoints';

export const makeGetRefundModalities = (): GetRefundModalities =>
	new RemoteRefundGetModalities(
		makeBFFApiUrl(RefundFlowEndPoints.modalities),
		makeAuthorizeHttpClientDecorator(),
	);
